import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const FLAG_REPORT_INITIAL: any = {
  reports: [],
  isLoading: false,
  error: null,
};

const flagReportSlice = createSlice({
  name: "flagReport",
  initialState: {
    ...FLAG_REPORT_INITIAL,
  },
  reducers: {
    FLAG_REPORT_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Date;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { FLAG_REPORT_UPDATE } = flagReportSlice.actions;

export { flagReportSlice, FLAG_REPORT_INITIAL, FLAG_REPORT_UPDATE };
